var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("attachments.import_file") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-start" },
            [
              _c(
                "b-col",
                {
                  staticClass: "pt-2 my-1 mr-5 font-weight-bold",
                  attrs: { xl: "2", offset: "2" },
                },
                [
                  _c("label", { staticClass: "text-dark" }, [
                    _vm._v(_vm._s(_vm.$t("common.chse_file_up"))),
                  ]),
                  _vm._v(" *\n      "),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mr-5 form-group", attrs: { xl: "4" } },
                [
                  _c("input", {
                    ref: "fileInput",
                    staticClass: "form-control",
                    attrs: {
                      type: "file",
                      name: "file2",
                      id: "file2",
                      accept: ".csv",
                    },
                    on: { change: _vm.onFileChange },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "ml-5 form-group text-center",
                  attrs: { xl: "1" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticStyle: { width: "135px" },
                      attrs: { variant: "primary", size: "lg" },
                      on: { click: _vm.importAttachment },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("bank_accounts.imprt"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { xl: "12", offset: "2" } }, [
                _c("i", [
                  _vm._v(_vm._s(_vm.$t("common.asterisk_obligation_label"))),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }